import { API } from "../config/axiosConfig";

export const marketplaceModule = {
  getTCGCategories: async () => {
    try {
      const response = await API.get("/api/cards/tcg-categories/");
      return {
        success: true,
        data: response.data?.data || [],
        message: response.data?.message || "TCG categories fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch TCG categories",
        error: error.response?.data || error,
      };
    }
  },

  getTCGCategoryRarities: async (tcgCategoryId) => {
    try {
      const response = await API.get("/api/cards/tcg-category-rarities/", {
        params: { tcg_category_id: tcgCategoryId },
      });
      return {
        success: true,
        data: response.data?.data || [],
        message:
          response.data?.message || "TCG category rarities fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch TCG category rarities",
        error: error.response?.data || error,
      };
    }
  },

  getTCGCategoryCatalogs: async (tcgCategoryId) => {
    try {
      const response = await API.get("/api/cards/tcg-category-catalogs/", {
        params: {
          tcg_category_id: tcgCategoryId,
        },
      });
      return {
        success: true,
        data: response.data?.data || [],
        message:
          response.data?.message || "TCG category catalogs fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch TCG category catalogs",
        error: error.response?.data || error,
      };
    }
  },

  getCatalogProducts: async (catalogGroupId, params = {}) => {
    try {
      const queryParams = {
        catalog_group_id: catalogGroupId,
        ...params,
      };
      const response = await API.get("/api/cards/catalog-products/", {
        params: queryParams,
      });
      return {
        success: true,
        data: response.data?.data || [],
        message:
          response.data?.message || "Catalog products fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch catalog products",
        error: error.response?.data || error,
      };
    }
  },
};

export default marketplaceModule;

